import { render, staticRenderFns } from "./post-text.vue?vue&type=template&id=05207966&scoped=true&"
import script from "./post-text.vue?vue&type=script&lang=js&"
export * from "./post-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05207966",
  null
  
)

export default component.exports